export default "__VITE_ASSET__8ffb067a__"